import React, { useState, useEffect } from 'react';
import './App.css';
import Leaderboard from './components/Leaderboard';
import dinoIcon from './assets/dino-icon.svg';

function App() {
  const [balances, setBalances] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchBalances(true); // true = первоначальная загрузка
    
    // Устанавливаем автообновление каждые 10 секунд
    const interval = setInterval(() => {
      fetchBalances(false); // false = автообновление без loading
    }, 10000);

    // Очищаем интервал при размонтировании компонента
    return () => clearInterval(interval);
  }, []);

  const fetchBalances = async (showLoading = false) => {
    try {
      if (showLoading) {
        setLoading(true);
      } else {
        setRefreshing(true);
      }
      setError(null);
      
      const response = await fetch('https://api.icodrops.com/hyperliquid-parser/competition/balances');
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      setBalances(data);
    } catch (err) {
      setError(`Data loading error: ${err.message}`);
      console.error('Fetch error:', err);
    } finally {
      if (showLoading) {
        setLoading(false);
      } else {
        setRefreshing(false);
      }
    }
  };

  const handleRefresh = () => {
    fetchBalances(true); // Ручное обновление показывает loading
  };

  return (
    <div className="App">
      <div className="container">
        <header className="header">
          <h1 className="title">
            <img src={dinoIcon} alt="FOMO Dino" className="dino-icon" />
            FOMO Competition Leaderboard
          </h1>
          <div className="header-controls">
            <button className="refresh-btn" onClick={handleRefresh} disabled={loading || refreshing}>
              {loading ? '🔄 Loading...' : refreshing ? '🔄 Updating...' : '🔄 Refresh'}
            </button>
          </div>
        </header>

        {error && (
          <div className="error-message">
            <span>❌ {error}</span>
            <button onClick={handleRefresh} className="retry-btn">
              Try Again
            </button>
          </div>
        )}

        {loading ? (
          <div className="loading">
            <div className="spinner"></div>
            <p>Loading data...</p>
          </div>
        ) : (
          <Leaderboard balances={balances} />
        )}
      </div>
    </div>
  );
}

export default App;
